

export const setCurrentInteractionAction = (
  id: string,
  updateFocusedNodeId
) => {
  return {
    type: 'SET_CURRENT_INTERACTION',
    data: { id: id, updateFocusedNodeId },
  };
};
